var map = {
	"./af/RestaurantAdmins.json": 77864,
	"./af/common.json": 75462,
	"./af/login.json": 96,
	"./af/menu.json": 97716,
	"./af/register.json": 27050,
	"./af/welcome.json": 56389,
	"./en/App.json": 12374,
	"./en/common.json": 79802,
	"./en/login.json": 30788,
	"./en/menu.json": 32048,
	"./en/register.json": 38806,
	"./en/welcome.json": 81097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15502;